import React from "react";
//eslint-disable-next-line
import styles from "./Error404.module.css";

const Error404New = () => {
  return (
    <div style={{ placeSelf: "center" }}>
      <p>page not found</p>
    </div>
  );
};

export default Error404New;
